import { defineComponent } from "vue";

// Components
import MainBarMenuV2 from "@/components/layouts/MainBarMenuV2.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import Typography from "@/components/general/Typography";
import Button from "@/components/general/Button";
import useInputs from "@/components/general/Inputs";
import Breadcrumb from "@/components/general/Breadcrumb";
import ChangeHistoryLegal from "@/components/datatables/ChangeHistoryLegal.vue";

// services
import processSevices from "@/services/legal/service.js";

const { Input } = useInputs();

export default defineComponent({
  name: "Legal_process_history",
  components: {
    MainBarMenuV2,
    HeadingUser,
    Typography,
    Button,
    Input,
    Breadcrumb,
  },
  data() {
    return {
      breadcrumb: [
        { name: "Procesos", active: false, link: "/legal/process" },
        { name: "Historial de modificaciones", active: true, link: "" },
      ],
      file_number: '',
      pagina: 1,
      pagination: {},
      datatable: {
        filter: "",
        total: 10,
        per_page: 10,
        page: 1,
        last_page: 1,
        columns: [
          {
            label: "Fecha y hora ",
            field: "created_at",
            align: "left",
            sortable: true,
            headerClass: "text-left table-th",
            representedAs: ({ created_at }) => this.$moment(created_at).format("YYYY-M-D hh:mm:ss"),
            interpolate: true,
          },
          {
            label: "Evento",
            field: "event.name",
            align: "left",
            sortable: true,
            headerClass: "text-left table-th",
          },
          {
            label: "Abogado",
            field: "lawyer.name",
            align: "left",
            sortable: true,
            headerClass: "text-left table-th",
          },
          {
            label: "Cambios",
            align: "left",
            sortable: true,
            component: ChangeHistoryLegal,
            headerClass: "text-left table-th",
          },
          /*{
            label: "Abogado",
            field: "lawyer.name",
            align: "left",
            sortable: true,
            headerClass: "text-left table-th",
          } */
        ],
        rows: [],
      },
    };
  },
  methods: {
    getDatafilter() {
      console.log("get data");
    },
    goCreate() {
      this.$router.push("process/create");
    },
    initData() {
      processSevices.getProcess(this.$route.params.id).then((response) => {
        this.file_number = response.data.file_number;
        processSevices.getModifications({process_id: this.$route.params.id}).then((response) => {
          this.datatable.rows = response.data;
          this.datatable.total = response.meta.total;
          this.datatable.per_page = response.meta.per_page;
          this.datatable.last_page = response.meta.last_page;
          this.datatable.page = response.meta.current_page;
        })
      });
    },
  },
  mounted() {
    this.initData();
  },
});
